import { useQuery } from '@tanstack/react-query';
import { Megaphone } from 'lucide-react';
import { Loading, Page, Problem } from '../components/ui.jsx';
import { APP_VERSION, ReleaseAreas, releaseAreas, type ReleaseNotesDocument } from '../release.jsx';

const dateFormat = new Intl.DateTimeFormat('it-IT', { dateStyle: 'long' });

/** Every version, newest first, read from the same document the update guard watches. */
export function ReleaseNotes() {
  const notes = useQuery({
    queryKey: ['release-notes'],
    queryFn: async () => {
      const response = await fetch('/release-notes.json', { cache: 'no-store' });
      if (!response.ok) throw new Error('Le note di rilascio non sono disponibili');
      return (await response.json()) as ReleaseNotesDocument;
    },
    staleTime: 5 * 60_000,
  });

  return (
    <Page
      eyebrow="SISTEMA"
      title="Note di rilascio"
      description="Che cosa è cambiato in ogni versione, dalla più recente."
      actions={
        <span className="release-current">
          <Megaphone size={15} /> v{APP_VERSION}
        </span>
      }
    >
      {notes.error ? <Problem error={notes.error} /> : null}
      {notes.isLoading ? <Loading what="le note di rilascio" /> : null}
      <div className="release-list">
        {notes.data?.releases.map((release) => (
          <article key={release.version} className="card">
            <header>
              <span className="eyebrow">VERSIONE {release.version}</span>
              <h2>{release.summary}</h2>
              <time dateTime={release.publishedAt}>{dateFormat.format(new Date(release.publishedAt))}</time>
            </header>
            <div>
              <ReleaseAreas areas={releaseAreas(release)} />
            </div>
          </article>
        ))}
      </div>
    </Page>
  );
}
